import React from "react";
import ReactDOM from "react-dom";
// Imported before App so Tailwind's base layer sits at the top of the cascade
// and ends up in the render-blocking main stylesheet. Component styles are
// loaded after this and can still override it.
import "./index.css";
// Loaded after index.css so it wins ties against the theme's own rules, and
// from here rather than a component so it lands in the render-blocking bundle
// instead of a route chunk.
import "./styles/touch-targets.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore } from "redux";
import { Provider } from "react-redux";

// Define the initial state inline
const initialState = {
  userId: null,
  fullName: "",
  email: "",
  image: null,
  agentId: null,
  role: null,
  // null = session not yet checked, true/false = result of GET /users/me
  isAuthenticated: null,
};

// Define the reducer inline
const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        userId: action.payload.userId,
        fullName: action.payload.fullName,
        email: action.payload.email,
        image: action.payload.image,
      };
    case "SET_AGENT_ID":
      return {
        ...state,
        agentId: action.payload.agentId,
      };
    case "SET_SESSION":
      return {
        ...state,
        userId: action.payload.userId,
        fullName: action.payload.fullName,
        email: action.payload.email,
        image: action.payload.image,
        role: action.payload.role,
        isAuthenticated: true,
      };
    case "CLEAR_SESSION":
      return { ...initialState, isAuthenticated: false };
    default:
      return state;
  }
};

// Create the store directly in index.js
const store = createStore(rootReducer);

ReactDOM.render(
  <React.StrictMode>

    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
